export const LockChangedNote = ({ address, testId }) =>
  address.lock_changed ? (
    <div className="mt-3 rounded-lg border-l-4 border-emerald-500 bg-emerald-50 p-3 text-sm text-slate-800" data-testid={testId}>
      <span className="font-semibold">Lock changed</span>
      {address.lock_type && <span> · Lock type: {address.lock_type}</span>}
      {address.key_safe_code && <span> · Key Safe Code: <span className="font-data font-semibold">{address.key_safe_code}</span></span>}
      {address.no_key_safe && <span> · No key safe</span>}
      <span> · Key return phone: <span className="font-data font-semibold">{address.phone_left ? address.key_return_phone || "Yes" : "Not left"}</span></span>
    </div>
  ) : null;
